"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableArrowRight = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.TableArrowRight = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { width: "17", height: "17", viewBox: "0 0 50 100" }),
    React.createElement("path", { d: "M50 50L0 95L0 5L50 50Z", fill: props.fill || common_styles_1.black, stroke: props.stroke || common_styles_1.black }))); };
//# sourceMappingURL=tablearrowright.js.map